/* ==========================================================================
   NADAYA／mu 台湾向け越境EC
   Block 5：日本のSNSで賑わう様子（nd-buzz）— 投稿埋め込みモーダル

   ・グリッドはドラフトどおりの 9:16 サムネイルカードのまま。
     カードをクリックしたときだけモーダルを開き、その中に台湾向けIG／FB投稿を
     埋め込む（埋め込み要素はクリックまで一切生成しない）。
   ・埋め込みは各SNSのiframeエンドポイントを直接使用し、外部スクリプト
     （instagram embed.js / facebook sdk.js）は読み込まない。
     ページ読み込み時に third-party へのリクエストが発生しないため、
     LCP・CLS への影響はゼロ。
   ・<dialog> 非対応、またはJSがブロックされた環境では preventDefault せず、
     カードは通常のリンクとして投稿ページへ遷移する（フォールバック）。
   ・モーダル内にも投稿への導線を常時表示し、iframeがCookie制限等で
     表示されない場合の逃げ道とする。
   ・フォローボタンは設置しない（フッターのSNSアイコンに集約）。

   表示テキストは多言語展開のためすべてschema管理。
   Liquid側から data-* 属性で受け取り、このファイルには直書きしない。
   ========================================================================== */
(function () {
  'use strict';

  var CARD_SELECTOR = '.nd-buzz__reel[data-nd-embed]';
  var dialog = null;
  var elTitle = null;
  var elFrame = null;
  var elLink = null;
  var lastOpener = null;

  /* <dialog> のモーダル表示に対応しているか。
     非対応ならモーダル化せず、通常のリンク遷移に委ねる。 */
  function isSupported() {
    return (
      typeof window.HTMLDialogElement === 'function' &&
      typeof window.HTMLDialogElement.prototype.showModal === 'function'
    );
  }

  /* モーダルの器を1つだけ生成して使い回す */
  function build(closeLabel) {
    if (dialog) {
      return dialog;
    }

    dialog = document.createElement('dialog');
    dialog.className = 'nd-buzz-modal';

    var inner = document.createElement('div');
    inner.className = 'nd-buzz-modal__inner';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'nd-buzz-modal__close';
    close.setAttribute('aria-label', closeLabel || '');
    close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    close.addEventListener('click', function () {
      dialog.close();
    });

    elTitle = document.createElement('p');
    elTitle.className = 'nd-buzz-modal__title';

    elFrame = document.createElement('div');
    elFrame.className = 'nd-buzz-modal__frame';

    elLink = document.createElement('a');
    elLink.className = 'nd-buzz-modal__link';
    elLink.target = '_blank';
    elLink.rel = 'noopener';

    inner.appendChild(close);
    inner.appendChild(elTitle);
    inner.appendChild(elFrame);
    inner.appendChild(elLink);
    dialog.appendChild(inner);

    /* 背景（::backdrop）クリックで閉じる */
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    /* 閉じたらiframeを破棄して再生を止め、フォーカスを元のカードへ戻す */
    dialog.addEventListener('close', function () {
      elFrame.innerHTML = '';
      if (lastOpener && typeof lastOpener.focus === 'function') {
        lastOpener.focus();
      }
      lastOpener = null;
    });

    document.body.appendChild(dialog);
    return dialog;
  }

  function open(card) {
    var grid = card.closest('.nd-buzz__grid');
    var closeLabel = grid ? grid.getAttribute('data-nd-close-label') : '';

    build(closeLabel);
    lastOpener = card;

    var caption = card.getAttribute('data-nd-embed-title') || '';
    elTitle.textContent = caption;
    elTitle.hidden = caption === '';

    var cta = card.getAttribute('data-nd-embed-cta') || '';
    elLink.textContent = cta;
    elLink.href = card.getAttribute('href') || '#';
    elLink.hidden = cta === '';

    /* iframeはこの時点で初めて生成する */
    var frame = document.createElement('iframe');
    frame.src = card.getAttribute('data-nd-embed');
    frame.title = caption;
    frame.loading = 'lazy';
    frame.setAttribute('frameborder', '0');
    frame.setAttribute('scrolling', 'no');
    frame.setAttribute('allowfullscreen', 'true');
    frame.setAttribute(
      'allow',
      'autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'
    );

    elFrame.innerHTML = '';
    elFrame.appendChild(frame);

    dialog.showModal();
  }

  /* --------------------------------------------------------------------
     サムネイル代わりの埋め込みプレビュー（画像未設定のカードのみ）。
     カードが画面に近づいてから src を設定する。ページ読み込み時には
     third-party へのリクエストを発生させない。
     -------------------------------------------------------------------- */
  function load(frame) {
    var src = frame.getAttribute('data-nd-preview');
    if (!src) {
      return;
    }
    frame.removeAttribute('data-nd-preview');
    frame.src = src;
  }

  function initPreviews(root) {
    var frames = (root || document).querySelectorAll('.nd-buzz__preview[data-nd-preview]');
    if (!frames.length) {
      return;
    }

    /* IntersectionObserver 非対応環境では即座に読み込む
       （iframe の loading="lazy" に委ねる） */
    if (typeof window.IntersectionObserver !== 'function') {
      Array.prototype.forEach.call(frames, load);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            load(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '300px 0px' }
    );

    Array.prototype.forEach.call(frames, function (frame) {
      observer.observe(frame);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPreviews(document);
    });
  } else {
    initPreviews(document);
  }

  /* テーマエディタでセクションを再描画したとき */
  document.addEventListener('shopify:section:load', function (event) {
    initPreviews(event.target);
  });

  document.addEventListener('click', function (event) {
    if (!isSupported()) {
      return;
    }

    var target = event.target;
    if (!target || typeof target.closest !== 'function') {
      return;
    }

    var card = target.closest(CARD_SELECTOR);
    if (!card) {
      return;
    }

    /* 修飾キー付きクリック（別タブで開く等）はブラウザの挙動を尊重する */
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    event.preventDefault();
    open(card);
  });

  /* テーマエディタでセクションを編集・削除したときに開きっぱなしにしない */
  document.addEventListener('shopify:section:unload', function () {
    if (dialog && dialog.open) {
      dialog.close();
    }
  });
})();
